<template>
  <div class="dropdown relative">
    <button
      @click="showOptions = !showOptions"
      :class="`btn btn-primary dropdown-toggle employee_field_button btn-outline`"
    >
      {{ placeholder }}
    </button>
    <div v-if="showOptions" class="items bg-white">
      <div
        v-for="option in options"
        :key="option.key"
        @click="$emit('action', option)"
        class="item pl-2 pr-3 py-1"
      >
        {{ option.data_field_name }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showOptions: false,
    };
  },
  created() {},
  methods: {},
};
</script>


<style lang="scss" scoped>
.btn {
  font-size: 9px !important;
}
.items {
  position: absolute;
  min-width: 100%;
  width: max-content;
  z-index: 10;

  .item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 9px !important;
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      cursor: pointer;
    }
  }
}
</style>